import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class MmuMainMenuService {

  static readonly sessionStorageMenuCollapsed = 'menuCollapsed';

  get mobileOpen$(): Observable<boolean> {
    return this._mobileMenuOpen.asObservable().pipe(distinctUntilChanged());
  }

  get collapsed$(): Observable<boolean> {
    return this._menuCollapsed.asObservable().pipe(distinctUntilChanged());
  }

  private readonly _mobileMenuOpen = new BehaviorSubject<boolean>(false);
  private readonly _menuCollapsed = new BehaviorSubject<boolean>(false);

  constructor(private router: Router) {
    this._mobileMenuOpen = new BehaviorSubject<boolean>(false);
    this._menuCollapsed = new BehaviorSubject<boolean>(this.getSessionStorageMenuState());
    this.initGlobalEvents();
  }

  getCollapsedState(): boolean {
    return this.getSessionStorageMenuState() ? this.getSessionStorageMenuState() : this._menuCollapsed.getValue();
  }

  open(open = true): void {
    this._mobileMenuOpen.next(open);
  }

  collapse(collapsed = true): void {
    this._menuCollapsed.next(collapsed);
  }

  toggleMobileOpen(): void {
    this.open(!this._mobileMenuOpen.getValue());
  }

  toggleCollapseState(): void {
    const nextMenuState = this._menuCollapsed.getValue();
    window.sessionStorage.setItem(MmuMainMenuService.sessionStorageMenuCollapsed, (!nextMenuState).toString());
    this.collapse(!nextMenuState);
  }

  // gets menu state from session storage
  getSessionStorageMenuState(): boolean {
    return window.sessionStorage.getItem(MmuMainMenuService.sessionStorageMenuCollapsed) === 'true';
  }

  private initGlobalEvents(): void {
    const windowResize$ = fromEvent(window, 'resize').pipe(debounceTime(100));

    /* Listen to the window resize event and close the mobile menu when the viewport changes */
    windowResize$
      .pipe(
        map(() => false)
      )
      .subscribe(this._mobileMenuOpen);

    /* Listen to routing events and close the mobile menu when navigation starts */
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationStart),
        map(() => false)
      )
      .subscribe(this._mobileMenuOpen);
  }
}
